import {Divider} from '@wix/wix-ui-tpa/cssVars'
import React from 'react'
import {classes} from './divider.st.css'

export const DividerExt = props => <Divider {...props} className={classes.root} ariaHidden />
